export default __webpack_public_path__ + "static/media/home.2e4302db.png";